/** @format */

// #region ::: UTILS
const REG_HAS_CDN = /^https?:\/\/cdn\.dovevivo\.it/;
const REG_FROM_CONTENTFUL_CDN = /^\/\//;

export const utilityFormatLowQualityPhoto = (raw: string) => {
  if (REG_FROM_CONTENTFUL_CDN.test(raw)) return raw;
  if (!REG_HAS_CDN.test(raw)) return `https://cdn.dovevivo.it${raw}`;
  return raw;
};

export const utilityFormatHighQualityPhoto = (raw: string) => {
  if (REG_FROM_CONTENTFUL_CDN.test(raw)) return raw;
  if (!REG_HAS_CDN.test(raw)) return `https://cdn.dovevivo.it${raw}`;
  return raw;
};
// #endregion

export const utilityGetRoomPictures = ({ media }: { media: any }) => {
  let photos = media?.filter(e => e.type === 'image');
  const photosLowQuality = photos?.map(photo => {
    const srcImage = photo?.altThumbnail || photo?.thumbnail || photo?.url;
    return utilityFormatLowQualityPhoto(srcImage);
  });
  const photosHighQuality = photos?.map(photo => utilityFormatHighQualityPhoto(photo?.altUrl || photo?.url));
  const itemVR = media?.find(photo => photo?.type === 'vr');

  return {
    hasMultiplePhotos: photos?.length > 1,
    photosLowQuality,
    photosHighQuality,
    urlVR: itemVR?.url,
    hasVR: !!itemVR,
  };
};
